import * as React from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  getUpsReadings,
  updateUpsReadingStatus,
} from "../../../services/infrastructure/UpsService";
import {
  ISearchUps,
  IDataCenter,
  IUPSReading,
  IReadingStatus,
  IFloorVM,
} from "../../../vm";
import {
  getADataCenter,
  getPowerComponents,
  getFloorsWhichHasUnits,
} from "../../../services/datacenter/DatacenterService";
import { ToastContext } from "../../common/ToastProvider";
import { Loading } from "../../../services/Loading";
import {
  Stack,
  Text,
  PrimaryButton,
  Dropdown,
  IDropdownOption,
  DatePicker,
  DayOfWeek,
  TooltipHost,
  Checkbox,
  DefaultButton,
  DropdownMenuItemType,
  IBreadcrumbItem,
  Breadcrumb,
  ISelectableOption,
  TextField,
  Callout,
  DirectionalHint,
  CommandBarButton,
  IIconProps,
} from "office-ui-fabric-react";
import {
  childrenGap,
  ODD_SHIFT,
  UPS_STATUS,
  READ_AT_TIME_FORMAT,
  childrenGap8,
  EVEN_SHIFT,
} from "../../common/Constants";
import moment from "moment";
import Icon from "@mdi/react";
import {
  mdiCheck,
  mdiChevronDoubleLeft,
  mdiChevronLeft,
  mdiChevronRight,
  mdiClose,
  mdiDotsVertical,
  mdiFloorPlan,
  mdiPencil,
} from "@mdi/js";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import ManageAllRejectDialog from "../../common/ManageAllRejectDialog";
import NoDataTile from "../../common/NoDataTile";
import { stat } from "fs";
import {
  getThreshold,
  getAlertDetails,
  isInThreshold,
  isValueLessThanThreshold,
} from "../../../services/ThresholdService";
import ManageUPSDialog from "./ManageUPSDialog";
import { THEME } from "../../../utils/Styles";
import ShowThresholdIcon from "../../common/ShowThresholdIcon";

export interface UpsMainProps { }

let iconBtnElement: HTMLElement;
let powerComponentDict: { [key: string]: any } = {};

const UpsMain: React.FC<UpsMainProps> = () => {
  // custom hooks
  const history = useHistory();
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isDatacenterFound: false,
    isUpsLoaded: false,
    upsList: [],
    allUpsDropdownList: [],
    allFloorsDropdownList: [],
    datacenter: undefined,
    searchObj: { datacenterId: "", date: new Date(), upsId: "" },
    upsReading: [],
    isIndeterminate: false,
    isAllChecked: false,
    selectedItems: [],
    upsObj: {},
    // threshold: {},
    manageUpsDialog: {
      isOpen: false,
      index: undefined,
      data: undefined,
    },
    manageRejectDialog: {
      isOpen: false,
      ids: [],
      remarks: "",
    },
    // isOpen: false,
    // id: "",
    // remarks: "",
    // isCallOutOpen: false,
    manageActionsCallout: {
      isOpen: false,
      element: undefined,
      data: undefined,
    },
  } as {
    isLoading: boolean;
    isDatacenterFound: boolean;
    isUpsLoaded: boolean;
    upsList: any[];
    allUpsDropdownList: IDropdownOption[];
    allFloorsDropdownList: IDropdownOption[];
    datacenter?: IDataCenter;
    searchObj: ISearchUps;
    upsReading: IUPSReading[];
    isIndeterminate: boolean;
    isAllChecked: boolean;
    selectedItems: string[];
    upsObj: any;
    // threshold: any;
    manageUpsDialog: {
      isOpen: boolean;
      index?: number;
      data?: IUPSReading;
    };
    manageRejectDialog: {
      isOpen: boolean;
      ids: string[];
      remarks?: string;
    };
    // isCallOutOpen: boolean;
    // isOpen: boolean;
    // id: string;
    // remarks?: string;
    manageActionsCallout: {
      isOpen: boolean;
      element: any;
      data?: IUPSReading;
    };
  });

  const [threshold, setThreshold] = React.useState({} as any);

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);
  const params: any = useParams();
  // const {s} = isInThreshold

  const isPuneDc2 = ["5f0570c337b0eb553b960600"].includes(params.dataCenterId);
  const isCalDc1 = ["5db6dd36b27b36223779fd7c"].includes(params.dataCenterId);

  React.useEffect(() => {
    const asyncFunc = async () => {
      if (params.dataCenterId) {
        getDatacenter(params.dataCenterId);
      }
    };
    asyncFunc();
  }, []);

  const getDatacenter = async (datacenterId: string) => {
    setState({ ...state, isLoading: true });

    let result = await getADataCenter(datacenterId);
    if (result?.success) {
      setState({
        ...state,
        datacenter: result.data,
        isDatacenterFound: true,
        isLoading: false,
      });
      getFloorList(result.data);
      // getThresholdData(result.data);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const getThresholdData = async (upsId: string) => {
    // setState({ ...state, isLoading: true });
    let result = await getThreshold("ups");
    if (result?.success) {
      // setThreshold(result.data.threshold);
      // setState({ ...state, threshold: result.data.threshold });
      const threshold = result.data.threshold
      if (isCalDc1) {
        threshold.loadIn.R.min = 1;
        threshold.loadIn.Y.min = 1;
        threshold.loadIn.B.min = 1;
      }
      setThresholdValue(upsId, threshold);
    } else {
      showToast(result?.message || "Error while getting datacenter", "error");
      // setState({ ...state, isDatacenterFound: false, isLoading: false });
    }
  };

  const handleLoading = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  const getFloorList = async (datacenter: IDataCenter) => {
    setState({ ...state, isLoading: true });
    let result = await getFloorsWhichHasUnits({
      dataCenterId: params.dataCenterId,
      type: "ups",
    });
    if (result?.success) {
      let options: IDropdownOption[] = [];

      const floorByBuilding: { [Key: string]: IFloorVM[] } = result.data.reduce(
        (acc: any, d) => {
          if (acc[d.buildingId] == null) {
            acc[d.buildingId] = [];
          }

          acc[d.buildingId].push(d);
          return acc;
        },
        {}
      );
      let temp = Object.keys(floorByBuilding);
      temp.forEach((d, index) => {
        options.push({
          key: d,
          text: floorByBuilding[d][0].buildingName,
          itemType: DropdownMenuItemType.Header,
        });
        floorByBuilding[d].forEach((f) => {
          options.push({
            key: f.floorId,
            text: f.floorName,
            data: { buildingName: f.buildingName },
          });
        });
        if (temp.length != index + 1) {
          options.push({
            key: "divider_1",
            text: "-",
            itemType: DropdownMenuItemType.Divider,
          });
        }
      });

      console.log("[options]", options);

      // result.data.forEach((ele: any) => {
      //   options.push({
      //     key: ele.floorId,
      //     text: `${ele.buildingName} - ${ele.floorName}`,
      //   });
      // });

      //   setState({
      //     ...state,
      //     isLoading: false,
      //     datacenter,
      //     isDatacenterFound: true,
      //     allFloorsDropdownList:options
      //   });
      getPowerComponentsList(datacenter, options);
    } else {
      setState({ ...state, isLoading: false });
    }
  };
  // const getThreshold = async (datacenterId: string) => {
  //   setState({ ...state, isLoading: true });
  //   let result = await getADataCenter(datacenterId);
  //   if (result?.success) {
  //     setState({
  //       ...state,
  //       datacenter: result.data,
  //       isDatacenterFound: true,
  //       isLoading: false,
  //     });
  //     getFloorList(result.data);
  //   } else {
  //     showToast(result?.message || 'Error while getting datacenter', 'error');
  //     setState({ ...state, isDatacenterFound: false, isLoading: false });
  //   }
  // };

  const getPowerComponentsList = async (
    datacenter: IDataCenter,
    allFloorsDropdownList: IDropdownOption[]
  ) => {
    setState({ ...state, isLoading: true });
    let result = await getPowerComponents({
      datacenterId: params.dataCenterId,
      types: ["ups"],
    });
    if (result?.success) {
      let upsObj = result.data.reduce((acc, ele) => {
        if (acc[ele.floorId] == null) {
          acc[ele.floorId] = [];
        }
        powerComponentDict[ele._id] = Number(ele.capacity);
        acc[ele.floorId].push({ key: ele._id, text: ele.name });
        return acc;
      }, {});
      //   let options: IDropdownOption[] = [];
      //   result.data.forEach((ele) => {
      //     options.push({ key: ele._id, text: ele.name });
      //   });

      let obj = {
        ...state,
        upsList: result.data,
        isLoading: false,
        datacenter,
        isDatacenterFound: true,
        searchObj: {
          datacenterId: params.dataCenterId,
          date: new Date(),
          // floorId:"",
          // upsId:"",
          floorId:
            allFloorsDropdownList.length > 1
              ? (allFloorsDropdownList[1].key as string)
              : "",
          upsId:
            allFloorsDropdownList.length > 1 &&
              upsObj[allFloorsDropdownList[1].key as string]
              ? upsObj[allFloorsDropdownList[1].key as string][0].key
              : "",
        },
        upsObj,
        allUpsDropdownList:
          (allFloorsDropdownList.length > 1 &&
            upsObj[allFloorsDropdownList[1].key as string]) ||
          [],
        allFloorsDropdownList,
      };
      getThresholdData(obj.searchObj.upsId);
      setState(obj);
      getUpsReadingsData(obj);
    } else {
      showToast(result?.message || "Error while getting ups list", "error");
      setState({ ...state, isLoading: false });
    }
  };
  const getUpsReadingsData = async (paramState?: any) => {
    let localState = { ...state };
    if (paramState != null) {
      localState = { ...paramState };
    }

    setState({ ...localState, isLoading: true });
    let obj = { ...localState.searchObj };
    obj.date = moment(obj.date).format("YYYY-MM-DD");
    let result = await getUpsReadings(obj);
    if (result?.success) {
      setState({
        ...localState,
        upsReading: result.data,
        isLoading: false,
        isUpsLoaded: true,
      });
    } else {
      showToast(result?.message || "Error while getting ups readings", "error");
      setState({ ...state, isLoading: false, isUpsLoaded: false });
    }
  };

  const setThresholdValue = (upsId: string, thresholdObj?: any) => {
    let thresholds = { ...threshold };
    if (thresholdObj) {
      thresholds = { ...thresholdObj };
    }

    const capacity = powerComponentDict[upsId];

    if (thresholds?.outputKW?.min && thresholds?.outputKW?.max) {
      thresholds.outputKW.min = 0;
      thresholds.outputKW.max = (capacity * 40) / 100;
    }

    if (thresholds?.outputKWA?.min && thresholds?.outputKWA?.max) {
      thresholds.outputKWA.min = 0;
      thresholds.outputKWA.max = (capacity * 40) / 100;
    }

    setThreshold(thresholds);
  };

  const onSearch = async () => {
    if (!state.searchObj.floorId) {
      showToast("Please select a floor before searching", "error");
      return;
    }
    if (!state.searchObj.upsId) {
      showToast("Please select an ups before searching", "error");
      return;
    }
    getUpsReadingsData();
    setThresholdValue(state.searchObj.upsId);
  };

  const handleAcceptOrReject = (id: string, isAccept: boolean) => {
    showConfirmDialog(
      "Are You Sure",
      `Do you want to ${isAccept ? "Accept" : "Reject"} the ups reading`,
      async () => {
        setState({
          ...state,
          isLoading: true,
          manageActionsCallout: {
            isOpen: false,
            element: undefined,
            data: undefined,
          },
        });
        let obj: IReadingStatus = {
          ids: [id],
          status: isAccept ? "approved" : "rejected",
        };
        let result = await updateUpsReadingStatus(obj);
        if (result?.success) {
          let upsReading = [...state.upsReading];
          let index = upsReading.findIndex((ele) => ele._id === id);
          if (index !== -1) {
            upsReading[index].status = isAccept ? "approved" : "rejected";
          }
          let selectedItems = [...state.selectedItems];
          let indexToRemove = selectedItems.findIndex((ele) => ele === id);
          if (index !== -1) {
            selectedItems.splice(indexToRemove, 1);
          }
          showToast(
            `Ups Reading ${isAccept ? "approved" : "rejected"} successfully`,
            "success"
          );
          setState({
            ...state,
            upsReading,
            selectedItems,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        } else {
          showToast(
            result?.message ||
            `An error occurred while ${isAccept ? "approving" : "rejecting"
            } a ups reading`,
            "error"
          );
          setState({
            ...state,
            isLoading: false,
            manageActionsCallout: {
              isOpen: false,
              element: undefined,
              data: undefined,
            },
          });
        }
      }
    );
  };

  // const onTextValueChange = (
  //   event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  //   textValue?: string
  // ) => {
  //   console.log("remarks", state.remarks);
  //   debugger;
  //   setState({ ...state, remarks: textValue as string });
  //   console.log("remarks", state.remarks);
  // };

  // const handleReject = (id: string, isAccept: boolean) => {
  //   console.log("reject clicked");
  //   showConfirmDialogOnReject(
  //     "Are You Sure",
  //     `Do you want to ${isAccept ? "Accept" : "Reject"} the ups reading`,
  //     <React.Fragment>
  //       <TextField
  //         value={state.remarks}
  //         // label={"Remarks"}
  //         placeholder={"enter your remarks here..."}
  //         onChange={onTextValueChange}
  //       />
  //     </React.Fragment>,

  //     async () => {
  //       setState({
  //         ...state,
  //         isLoading: true,
  //       });
  //       let obj: IReadingStatus = {
  //         ids: [id],
  //         status: isAccept ? "approved" : "rejected",
  //       };
  //       let result = await updateUpsReadingStatus(obj);
  //       if (result?.success) {
  //         let upsReading = [...state.upsReading];
  //         let index = upsReading.findIndex((ele) => ele._id === id);
  //         if (index !== -1) {
  //           upsReading[index].status = isAccept ? "approved" : "rejected";
  //         }
  //         let selectedItems = [...state.selectedItems];
  //         let indexToRemove = selectedItems.findIndex((ele) => ele === id);
  //         if (index !== -1) {
  //           selectedItems.splice(indexToRemove, 1);
  //         }
  //         showToast(
  //           `Ups Reading ${isAccept ? "approved" : "rejected"} successfully`,
  //           "success"
  //         );
  //         setState({
  //           ...state,
  //           upsReading,
  //           selectedItems,
  //           isLoading: false,
  //         });
  //       } else {
  //         showToast(
  //           result?.message ||
  //             `An error occurred while ${
  //               isAccept ? "approving" : "rejecting"
  //             } a ups reading`,
  //           "error"
  //         );
  //         setState({
  //           ...state,
  //           isLoading: false,
  //         });
  //       }
  //     }
  //   );
  // };

  const handleAcceptOrRejectSelected = (isAccept: boolean) => {
    if (isAccept) {
      showConfirmDialog(
        "Are You Sure",
        `Do you want to ${isAccept ? "Accept" : "Reject"} selected ups reading`,
        async () => {
          let selectedItems = [...state.selectedItems];
          let upsReading = [...state.upsReading];
          setState({
            ...state,
            isLoading: true,
          });
          let obj: IReadingStatus = {
            ids: selectedItems,
            status: isAccept ? "approved" : "rejected",
          };
          let result = await updateUpsReadingStatus(obj);
          if (result?.success) {
            selectedItems.forEach((item) => {
              let index = upsReading.findIndex((ele) => ele._id === item);
              if (index !== -1) {
                upsReading[index].status = isAccept ? "approved" : "rejected";
              }
            });
            showToast(
              `Ups Reading ${isAccept ? "approved" : "rejected"} successfully`,
              "success"
            );
            setState({
              ...state,
              upsReading,
              selectedItems: [],
              isLoading: false,
            });
          } else {
            showToast(
              result?.message ||
              `An error occurred while ${isAccept ? "approving" : "rejecting"
              } a ups reading`,
              "error"
            );
            setState({
              ...state,
              isLoading: false,
            });
          }
        }
      );
    } else {
      let selectedItems = [...state.selectedItems];
      handleRejectAllOpenDialog(selectedItems);
    }
  };

  const onSelectAll = (isAllChecked: boolean) => {
    let selectedItems: string[] = [];
    if (isAllChecked) {
      state.upsReading.forEach((ele) => {
        if (ele.status === "submitted") {
          selectedItems.push(ele._id as string);
        }
      });
      setState({ ...state, isAllChecked: true, selectedItems });
    } else {
      setState({ ...state, isAllChecked: false, selectedItems });
    }
  };

  const onIndividualSelect = (id: string) => {
    let selectedItems = [...state.selectedItems];
    let index = selectedItems.findIndex((e) => e === id);
    if (index === -1) {
      selectedItems.push(id);
    } else {
      selectedItems.splice(index, 1);
    }
    let isAllChecked = true;
    state.upsReading.forEach((ele) => {
      if (
        ele.status === "submitted" &&
        selectedItems.includes(ele._id as string) === false
      ) {
        isAllChecked = false;
      }
    });
    setState({ ...state, selectedItems, isAllChecked });
  };

  const getMinValue = (property: string) => {
    let a = property.split(".");
    if (state.upsReading.length > 0) {
      let list = state.upsReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      return Math.min(...list);
    } else {
      return "";
    }
  };
  const getMaxValue = (property: string) => {
    let a = property.split(".");
    if (state.upsReading.length > 0) {
      let list = state.upsReading.map((ele: any) => {
        if (a[1]) {
          return ele[a[0]] ? ele[a[0]][a[1]] : "";
        } else {
          return ele[a[0]];
        }
      });
      return Math.max(...list);
    } else {
      return "";
    }
  };
  const onRenderOption = (option?: ISelectableOption): JSX.Element => {
    if (!option) return <div />;
    return (
      <div className="d-flex">
        {/* {!option.itemType && <Icon path={mdiFloorPlan} size={0.8} />} */}
        <span style={{ marginLeft: option.itemType ? "0px" : "12px" }}>
          {option.text}
        </span>
      </div>
    );
  };

  const onRenderTitle = (options?: IDropdownOption[]): JSX.Element => {
    if (!options) return <div />;
    const option = options[0];

    return (
      <div>
        <span>{option.data.buildingName + "-" + option.text}</span>
      </div>
    );
  };

  const handleOpenDialog = (isOpen: boolean, id?: string) => {
    let upsReadingItem = undefined;
    let index = undefined;
    if (id !== undefined) {
      let idcReadingList = [...state.upsReading];
      index = idcReadingList.findIndex((e) => e._id === id);
      upsReadingItem = { ...state.upsReading[index] };
    }
    setState({
      ...state,
      manageUpsDialog: {
        isOpen: isOpen,
        index: index,
        data: upsReadingItem,
      },
    });
  };

  const handleCloseDialog = (data: IUPSReading) => {
    let readings = [...state.upsReading];
    if (data) {
      if (state.manageUpsDialog.index !== undefined) {
        readings[state.manageUpsDialog.index] = data;
      }
    }
    setState({
      ...state,
      manageUpsDialog: {
        isOpen: false,
        index: undefined,
        data: undefined,
      },
      upsReading: readings,
    });
  };

  const handleRejectAllOpenDialog = (ids: string[]) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: ids || [],
        remarks: "",
      },
    });
  };
  const handleRejectOpenDialog = (id: string, remarks?: string) => {
    setState({
      ...state,
      manageRejectDialog: {
        isOpen: true,
        ids: [id],
        remarks: remarks || "",
      },
    });
  };

  const handleRejectCloseDialog = async (
    isSuccess: boolean,
    remarks?: string
  ) => {
    let upsReading = [...state.upsReading];
    let selectedItems: string[] = state.manageRejectDialog.ids;
    if (isSuccess) {
      setState({
        ...state,
        isLoading: true,
      });
      let obj: IReadingStatus = {
        ids: selectedItems,
        status: "rejected",
        remarks: remarks || "",
      };
      let result = await updateUpsReadingStatus(obj);
      if (result?.success) {
        selectedItems.forEach((item) => {
          let index = upsReading.findIndex((ele) => ele._id === item);
          if (index !== -1) {
            upsReading[index].status = "rejected";
            upsReading[index].remarks = remarks || "";
          }
        });
        showToast(`Ups Reading rejected successfully`, "success");
        setState({
          ...state,
          upsReading,
          selectedItems: [],
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      } else {
        showToast(
          result?.message || `An error occurred while rejecting a ups reading`,
          "error"
        );
        setState({
          ...state,
          manageRejectDialog: {
            isOpen: false,
            ids: [],
            remarks: undefined,
          },
          isLoading: false,
        });
      }

      // if (state.manageUpsDialog.index !== undefined) {
      //   readings[state.manageUpsDialog.index] = data;
      // }
    } else {
      setState({
        ...state,
        manageRejectDialog: {
          isOpen: false,
          ids: [],
          remarks: undefined,
        },
        upsReading,
      });
    }
  };

  const onNextOrPrevFunc = (isPrev: boolean) => {
    let localState = { ...state };

    let currentSelectedFloor = localState.searchObj.floorId;
    let currentFloorList = localState.allFloorsDropdownList;
    let currentSelectedUps = localState.searchObj.upsId;
    let currentUpsList = localState.allUpsDropdownList;

    let currentUpsIndex = currentUpsList.findIndex(
      (d) => d.key === currentSelectedUps
    );

    if (isPrev) {
      if (currentUpsIndex !== 0) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            upsId: currentUpsList[currentUpsIndex - 1].key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === 1) return;
        let currentFloor = currentFloorList[currentFloorIndex - 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex - 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentUpsList = localState.upsObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            upsId: currentUpsList[currentUpsList.length - 1].key as string,
          },
          allUpsDropdownList: currentUpsList,
        };
      }
    } else {
      if (currentUpsIndex !== currentUpsList.length - 1) {
        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            upsId: currentUpsList[currentUpsIndex + 1].key as string,
          },
        };
      } else {
        let currentFloorIndex = currentFloorList.findIndex(
          (d) => d.key === currentSelectedFloor
        );
        if (currentFloorIndex === currentFloorList.length - 1) return;
        let currentFloor = currentFloorList[currentFloorIndex + 1];
        if (currentFloor.itemType) {
          // this is due to divider and header
          currentFloor = currentFloorList[currentFloorIndex + 3];
        }
        currentSelectedFloor = currentFloor.key as string;

        currentUpsList = localState.upsObj[currentSelectedFloor];

        localState = {
          ...localState,
          searchObj: {
            ...localState.searchObj,
            floorId: currentSelectedFloor,
            upsId: currentUpsList[0].key as string,
          },
          allUpsDropdownList: currentUpsList,
        };
      }
    }
    console.log("[onNextOrPrevFunc localState]", localState);
    getUpsReadingsData(localState);
  };

  const handleCallOutOpenClose = (
    isOpen: boolean,
    ele?: React.MouseEvent<HTMLSpanElement>,
    data?: IUPSReading
  ) => {
    setState({
      ...state,
      manageActionsCallout: {
        isOpen,
        element: isOpen ? ele?.currentTarget : undefined,
        data,
      },
    });
  };

  // const handleCallOutClose = () => {
  //   setState({
  //     ...state,
  //     isCallOutOpen: false,
  //     isOpen: false,
  //     id: "",
  //     remarks: "",
  //   });
  // };

  // let _actionsIconElement: React.RefObject<any>;
  // _actionsIconElement = React.createRef();

  // const lessThanIcon: IIconProps = { iconName: "less-than", color: "" };
  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isDatacenterFound ? (
        <React.Fragment>
          <Stack>
            <Stack.Item>
              <Stack.Item>
                {/* <Text variant='xLarge'>
                  UPS Readings - {state.datacenter && state.datacenter.name}{' '}
                  {state.datacenter && state.datacenter.location && ' - '}
                  {state.datacenter && state.datacenter.location}
                </Text> */}
                <Breadcrumb
                  items={[
                    {
                      text: state.datacenter
                        ? state.datacenter.name
                        : "Datacenter",
                      key: "datacenter",
                    },
                    {
                      text: "Infrastructures",
                      key: "infrastructure",
                      onClick: () => {
                        history.goBack();
                      },
                    },
                    {
                      text: "UPS Readings",
                      key: "ups-readings",
                      isCurrentItem: true,
                    },
                  ]}
                />
              </Stack.Item>
            </Stack.Item>
          </Stack>
          <br />
          <Stack horizontal horizontalAlign="start">
            <Stack.Item>
              <Stack horizontal wrap tokens={childrenGap}>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a Floor"
                    selectedKey={state.searchObj.floorId}
                    // defaultSelectedKey={state.searchObj.floorId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allFloorsDropdownList}
                    onRenderOption={onRenderOption}
                    onRenderTitle={onRenderTitle}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            floorId: v.key as string,
                            // upsId: '',
                            upsId: state.upsObj[v.key][0].key,
                          },
                          allUpsDropdownList: state.upsObj[v.key],
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <Dropdown
                    placeholder="Select a UPS"
                    // label="Role"
                    selectedKey={state.searchObj.upsId}
                    // defaultSelectedKey={state.searchObj.upsId}
                    styles={{ dropdown: { width: 200 } }}
                    options={state.allUpsDropdownList}
                    onChange={(e, v: IDropdownOption | undefined) => {
                      if (v) {
                        setState({
                          ...state,
                          searchObj: {
                            ...state.searchObj,
                            upsId: v.key as string,
                          },
                        });
                      }
                    }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <DatePicker
                    firstDayOfWeek={DayOfWeek.Sunday}
                    showMonthPickerAsOverlay={true}
                    value={new Date(state.searchObj.date)}
                    showGoToToday={false}
                    onSelectDate={(date: Date | null | undefined) =>
                      setState({
                        ...state,
                        searchObj: { ...state.searchObj, date: date as Date },
                      })
                    }
                    placeholder="Select a date..."
                    ariaLabel="Select a date"
                    styles={{ root: { width: 200 } }}
                  />
                </Stack.Item>
                <Stack.Item>
                  <PrimaryButton text="Search" onClick={() => onSearch()} />
                </Stack.Item>
              </Stack>
            </Stack.Item>
            {/* <Stack.Item>
             <DefaultButton
              text="Accept"
                 className="mr-8"
                 disabled={state.selectedItems.length === 0}
                 onClick={() => handleAcceptOrRejectSelected(true)}
               />
             &nbsp;&nbsp;
            <DefaultButton
              text="Reject"
                 disabled={state.selectedItems.length === 0}
                 onClick={() => handleAcceptOrRejectSelected(false)}
               />
             </Stack.Item> */}
          </Stack>
          <Stack
            horizontal
            horizontalAlign="space-between"
            wrap
            className="pt-16"
          >
            <Stack.Item className="ml-6">
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allUpsDropdownList[0]?.key === state.searchObj.upsId)
                    ? undefined
                    : () => onNextOrPrevFunc(true)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[1]?.key ===
                      state.searchObj.floorId &&
                      state.allUpsDropdownList[0]?.key === state.searchObj.upsId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <Icon
                  path={mdiChevronLeft}
                  size={0.9}
                  className="btnIcon"
                  style={{
                    marginBottom: -6,
                    marginRight: -8,
                    color: "#135c8a",
                  }}
                />
                <DefaultButton
                  text="Previous UPS"
                  className="borderless-btn"
                // disabled={
                //   state.allFloorsDropdownList[1]?.key ===
                //     state.searchObj.floorId &&
                //   state.allUpsDropdownList[0]?.key === state.searchObj.upsId
                // }
                // onClick={() => {
                //   onNextOrPrevFunc(true);
                // }}
                />
              </span>
              <span className="nxt-prv-btn-border"></span>
              <span
                onClick={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allUpsDropdownList[
                        state.allUpsDropdownList.length - 1
                      ]?.key === state.searchObj.upsId)
                    ? undefined
                    : () => onNextOrPrevFunc(false)
                }
                className={
                  state.allFloorsDropdownList.length < 2 ||
                    (state.allFloorsDropdownList[
                      state.allFloorsDropdownList.length - 1
                    ]?.key === state.searchObj.floorId &&
                      state.allUpsDropdownList[
                        state.allUpsDropdownList.length - 1
                      ]?.key === state.searchObj.upsId)
                    ? "btn-disabled"
                    : "btn-enabled pointer"
                }
              >
                <DefaultButton
                  text="Next UPS"
                  // disabled={
                  //   state.allFloorsDropdownList[
                  //     state.allFloorsDropdownList.length - 1
                  //   ]?.key === state.searchObj.floorId &&
                  //   state.allUpsDropdownList[
                  //     state.allUpsDropdownList.length - 1
                  //   ]?.key === state.searchObj.upsId
                  // }
                  // onClick={() => {
                  //   onNextOrPrevFunc(false);
                  // }}
                  className="borderless-btn"
                />
                <Icon
                  path={mdiChevronRight}
                  size={0.9}
                  className="btnIcon"
                  style={{ marginBottom: -6, marginLeft: -8, color: "#135c8a" }}
                />
              </span>
            </Stack.Item>
            <Stack.Item>
              <DefaultButton
                text="Accept"
                className="mr-8 custom-secondary-btn"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(true)}
              />
              <DefaultButton
                text="Reject"
                disabled={state.selectedItems.length === 0}
                onClick={() => handleAcceptOrRejectSelected(false)}
                className="custom-secondary-btn"
              />
            </Stack.Item>
          </Stack>
          <br />
          {state.isUpsLoaded && (
            <Stack>
              <div className="office-table bg-white">
                <table className="ms-Table bordered-table w-100">
                  <thead className="html-table-thead">
                    <tr>
                      <th rowSpan={2}>
                        <Checkbox
                          //   indeterminate={state.isIndeterminate}
                          checked={state.isAllChecked}
                          onChange={(eve, checked) =>
                            onSelectAll(checked as boolean)
                          }
                        />
                      </th>
                      <th rowSpan={2}>Time (Hrs)</th>
                      <th rowSpan={2}>System</th>
                      <th colSpan={3}>Input Voltage</th>
                      <th colSpan={3}>Input Current</th>
                      <th colSpan={3}>Output Voltage</th>
                      <th colSpan={3}>Output Current</th>
                      {!isPuneDc2 && <th colSpan={3}>Load In %</th>}
                      <th rowSpan={2}>Output KW</th>
                      <th rowSpan={2}>Output KVA</th>
                      <th rowSpan={2}>Output Freq(Hz)</th>
                      {isPuneDc2 && <th rowSpan={2}>Load In %</th>}
                      <th colSpan={2}>Battery</th>
                      <th rowSpan={2}>UPS Room Temp ℃</th>
                      <th rowSpan={2}>Battery Room Temp ℃</th>
                      <th rowSpan={2}>Shift Tech Sign</th>
                      <th rowSpan={2}>Status</th>
                      <th rowSpan={2}>Remarks</th>
                      <th rowSpan={2}>Read At</th>
                      <th rowSpan={2}>Actions</th>
                    </tr>
                    <tr>
                      <th>RY</th>
                      <th>YB</th>
                      <th>BR</th>
                      <th>R</th>
                      <th>Y</th>
                      <th>B</th>
                      <th>RN</th>
                      <th>YN</th>
                      <th>BN</th>
                      <th>R</th>
                      <th>Y</th>
                      <th>B</th>
                      {!isPuneDc2 && (
                        <>
                          <th>R</th>
                          <th>Y</th>
                          <th>B</th>
                        </>
                      )}
                      <th>Volt</th>
                      <th>Current</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EVEN_SHIFT.map((ele, index) => {
                      let item = state.upsReading.find(
                        (e) => e.shiftTime === ele
                      );
                      return (
                        <tr key={index}>
                          <th>
                            <Checkbox
                              disabled={!item || item.status !== "submitted"}
                              checked={state.selectedItems.includes(
                                item?._id as string
                              )}
                              onChange={() =>
                                onIndividualSelect(item?._id as string)
                              }
                              className="ml-12"
                            />
                          </th>
                          <th> {ele} </th>
                          <td>
                            {item?.isSystemOn !== undefined
                              ? item?.isSystemOn === true
                                ? "On"
                                : "Off"
                              : ""}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputVoltage?.RY || "",
                                "inputVoltage.RY",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputVoltage?.RY || ""}
                            {isInThreshold(
                              item?.inputVoltage?.RY || "",
                              "inputVoltage.RY",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputVoltage?.RY || "",
                                      "inputVoltage.RY",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputVoltage?.YB || "",
                                "inputVoltage.YB",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputVoltage?.YB || ""}
                            {isInThreshold(
                              item?.inputVoltage?.YB || "",
                              "inputVoltage.YB",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputVoltage?.YB || "",
                                      "inputVoltage.YB",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputVoltage?.BR || "",
                                "inputVoltage.BR",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputVoltage?.BR || ""}
                            {isInThreshold(
                              item?.inputVoltage?.BR || "",
                              "inputVoltage.BR",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputVoltage?.BR || "",
                                      "inputVoltage.BR",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputCurrent?.R || "",
                                "inputCurrent.R",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputCurrent?.R || ""}
                            {isInThreshold(
                              item?.inputCurrent?.R || "",
                              "inputCurrent.R",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputCurrent?.R || "",
                                      "inputCurrent.R",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputCurrent?.Y || "",
                                "inputCurrent.Y",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputCurrent?.Y || ""}
                            {isInThreshold(
                              item?.inputCurrent?.Y || "",
                              "inputCurrent.Y",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputCurrent?.Y || "",
                                      "inputCurrent.Y",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.inputCurrent?.B || "",
                                "inputCurrent.B",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.inputCurrent?.B || ""}
                            {isInThreshold(
                              item?.inputCurrent?.B || "",
                              "inputCurrent.B",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.inputCurrent?.B || "",
                                      "inputCurrent.B",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputVoltage?.RN || "",
                                "outputVoltage.RN",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputVoltage?.RN || ""}
                            {isInThreshold(
                              item?.outputVoltage?.RN || "",
                              "outputVoltage.RN",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputVoltage?.RN || "",
                                      "outputVoltage.RN",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputVoltage?.YN || "",
                                "outputVoltage.YN",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputVoltage?.YN || ""}
                            {isInThreshold(
                              item?.outputVoltage?.YN || "",
                              "outputVoltage.YN",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputVoltage?.YN || "",
                                      "outputVoltage.YN",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputVoltage?.BN || "",
                                "outputVoltage.BN",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputVoltage?.BN || ""}
                            {isInThreshold(
                              item?.outputVoltage?.BN || "",
                              "outputVoltage.BN",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputVoltage?.BN || "",
                                      "outputVoltage.BN",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputCurrent?.R || "",
                                "outputCurrent.R",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputCurrent?.R || ""}
                            {isInThreshold(
                              item?.outputCurrent?.R || "",
                              "outputCurrent.R",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputCurrent?.R || "",
                                      "outputCurrent.R",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputCurrent?.Y || "",
                                "outputCurrent.Y",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputCurrent?.Y || ""}
                            {isInThreshold(
                              item?.outputCurrent?.Y || "",
                              "outputCurrent.Y",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputCurrent?.Y || "",
                                      "outputCurrent.Y",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputCurrent?.B || "",
                                "outputCurrent.B",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputCurrent?.B || ""}
                            {isInThreshold(
                              item?.outputCurrent?.B || "",
                              "outputCurrent.B",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputCurrent?.B || "",
                                      "outputCurrent.B",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          {!isPuneDc2 && (
                            <>
                              <td
                                className={
                                  isInThreshold(
                                    item?.loadIn?.R || "",
                                    "loadIn.R",
                                    threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.loadIn?.R || ""}
                                {isInThreshold(
                                  item?.loadIn?.R || "",
                                  "loadIn.R",
                                  threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.loadIn?.R || "",
                                          "loadIn.R",
                                          threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.loadIn?.Y || "",
                                    "loadIn.Y",
                                    threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.loadIn?.Y || ""}
                                {isInThreshold(
                                  item?.loadIn?.Y || "",
                                  "loadIn.Y",
                                  threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.loadIn?.Y || "",
                                          "loadIn.Y",
                                          threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                              <td
                                className={
                                  isInThreshold(
                                    item?.loadIn?.B || "",
                                    "loadIn.B",
                                    threshold
                                  )
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                {item?.loadIn?.B || ""}
                                {isInThreshold(
                                  item?.loadIn?.B || "",
                                  "loadIn.B",
                                  threshold
                                ) && (
                                    <ShowThresholdIcon
                                      isLessThan={
                                        isValueLessThanThreshold(
                                          item?.loadIn?.B || "",
                                          "loadIn.B",
                                          threshold
                                        ) as boolean
                                      }
                                    />
                                  )}
                              </td>
                            </>
                          )}
                          <td
                            className={
                              isInThreshold(
                                item?.outputKW || "",
                                "outputKW",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputKW || ""}
                            {isInThreshold(
                              item?.outputKW || "",
                              "outputKW",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputKW || "",
                                      "outputKW",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputKWA || "",
                                "outputKWA",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputKWA || ""}
                            {isInThreshold(
                              item?.outputKWA || "",
                              "outputKWA",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputKWA || "",
                                      "outputKWA",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.outputFrequency || "",
                                "outputFrequency",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.outputFrequency || ""}
                            {isInThreshold(
                              item?.outputFrequency || "",
                              "outputFrequency",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.outputFrequency || "",
                                      "outputFrequency",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          {isPuneDc2 && (
                            <td
                              className={
                                isInThreshold(
                                  item?.loadInPercentage || "",
                                  "loadInPercentage",
                                  threshold
                                )
                                  ? "text-danger"
                                  : ""
                              }
                            >
                              {item?.loadInPercentage || ""}
                              {isInThreshold(
                                item?.loadInPercentage || "",
                                "loadInPercentage",
                                threshold
                              ) && (
                                  <ShowThresholdIcon
                                    isLessThan={
                                      isValueLessThanThreshold(
                                        item?.loadInPercentage || "",
                                        "loadInPercentage",
                                        threshold
                                      ) as boolean
                                    }
                                  />
                                )}
                            </td>
                          )}
                          <td
                            className={
                              isInThreshold(
                                item?.battery?.voltage || "",
                                "battery.voltage",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.battery?.voltage || ""}
                            {isInThreshold(
                              item?.battery?.voltage || "",
                              "battery.voltage",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.battery?.voltage || "",
                                      "battery.voltage",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.battery?.current || "",
                                "battery.current",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.battery?.current || ""}
                            {isInThreshold(
                              item?.battery?.current || "",
                              "battery.current",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.battery?.current || "",
                                      "battery.current",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.roomTemperature || "",
                                "roomTemperature",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.roomTemperature || ""}
                            {isInThreshold(
                              item?.roomTemperature || "",
                              "roomTemperature",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.roomTemperature || "",
                                      "roomTemperature",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td
                            className={
                              isInThreshold(
                                item?.batteryRoomTemperature || "",
                                "batteryRoomTemperature",
                                threshold
                              )
                                ? "text-danger"
                                : ""
                            }
                          >
                            {item?.batteryRoomTemperature || ""}
                            {isInThreshold(
                              item?.batteryRoomTemperature || "",
                              "batteryRoomTemperature",
                              threshold
                            ) && (
                                <ShowThresholdIcon
                                  isLessThan={
                                    isValueLessThanThreshold(
                                      item?.batteryRoomTemperature || "",
                                      "batteryRoomTemperature",
                                      threshold
                                    ) as boolean
                                  }
                                />
                              )}
                          </td>
                          <td>{item?.recordedBy || ""}</td>
                          <td>
                            {item && item?.status
                              ? UPS_STATUS[item.status]
                              : ""}
                          </td>
                          <td>{item?.remarks || ""}</td>
                          <td>
                            {item?.date
                              ? moment(item.date).format(READ_AT_TIME_FORMAT)
                              : ""}
                          </td>
                          <td align="center" className="no-wrap">
                            {item && item?.status === "submitted" && (
                              <span
                                onClick={(ele) =>
                                  handleCallOutOpenClose(true, ele, item)
                                }
                              >
                                <Icon
                                  path={mdiDotsVertical}
                                  size={0.9}
                                  className="pointer"
                                  color="#135c8a"
                                />
                              </span>
                              // <React.Fragment>
                              //   <TooltipHost
                              //     content="Update UPS Readings"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleOpenDialog(true, item?._id)
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiPencil}
                              //         size={0.7}
                              //         className="pointer"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Accept"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleAcceptOrReject(
                              //           item?._id as string,
                              //           true
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiCheck}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="green"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              //   &nbsp;&nbsp;
                              //   <TooltipHost
                              //     content="Reject"
                              //     calloutProps={{ gapSpace: 0 }}
                              //   >
                              //     <span
                              //       onClick={() =>
                              //         handleRejectOpenDialog(
                              //           item?._id as string,
                              //           item?.remarks
                              //         )
                              //       }
                              //     >
                              //       <Icon
                              //         path={mdiClose}
                              //         size={0.8}
                              //         className="pointer"
                              //         color="red"
                              //       />
                              //     </span>
                              //   </TooltipHost>
                              // </React.Fragment>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td></td>
                      <th>Min Value</th>
                      <td></td>
                      <td>{getMinValue("inputVoltage.RY")}</td>
                      <td>{getMinValue("inputVoltage.YB")}</td>
                      <td>{getMinValue("inputVoltage.BR")}</td>
                      <td>{getMinValue("inputCurrent.R")}</td>
                      <td>{getMinValue("inputCurrent.Y")}</td>
                      <td>{getMinValue("inputCurrent.B")}</td>
                      <td>{getMinValue("outputVoltage.RN")}</td>
                      <td>{getMinValue("outputVoltage.YN")}</td>
                      <td>{getMinValue("outputVoltage.BN")}</td>
                      <td>{getMinValue("outputCurrent.R")}</td>
                      <td>{getMinValue("outputCurrent.Y")}</td>
                      <td>{getMinValue("outputCurrent.B")}</td>
                      <td>{getMinValue("loadIn.R")}</td>
                      <td>{getMinValue("loadIn.Y")}</td>
                      <td>{getMinValue("loadIn.B")}</td>
                      <td>{getMinValue("outputKW")}</td>
                      <td>{getMinValue("outputKWA")}</td>
                      <td>{getMinValue("outputFrequency")}</td>
                      <td>{getMinValue("battery.voltage")}</td>
                      <td>{getMinValue("battery.current")}</td>
                      <td>{getMinValue("roomTemperature")}</td>
                      <td>{getMinValue("batteryRoomTemperature")}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <th>Max Value</th>
                      <td></td>
                      <td>{getMaxValue("inputVoltage.RY")}</td>
                      <td>{getMaxValue("inputVoltage.YB")}</td>
                      <td>{getMaxValue("inputVoltage.BR")}</td>
                      <td>{getMaxValue("inputCurrent.R")}</td>
                      <td>{getMaxValue("inputCurrent.Y")}</td>
                      <td>{getMaxValue("inputCurrent.B")}</td>
                      <td>{getMaxValue("outputVoltage.RN")}</td>
                      <td>{getMaxValue("outputVoltage.YN")}</td>
                      <td>{getMaxValue("outputVoltage.BN")}</td>
                      <td>{getMaxValue("outputCurrent.R")}</td>
                      <td>{getMaxValue("outputCurrent.Y")}</td>
                      <td>{getMaxValue("outputCurrent.B")}</td>
                      <td>{getMaxValue("loadIn.R")}</td>
                      <td>{getMaxValue("loadIn.Y")}</td>
                      <td>{getMaxValue("loadIn.B")}</td>
                      <td>{getMaxValue("outputKW")}</td>
                      <td>{getMaxValue("outputKWA")}</td>
                      <td>{getMaxValue("outputFrequency")}</td>
                      <td>{getMaxValue("battery.voltage")}</td>
                      <td>{getMaxValue("battery.current")}</td>
                      <td>{getMaxValue("roomTemperature")}</td>
                      <td>{getMaxValue("batteryRoomTemperature")}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* <div className="next-prev-btn">
                <div>
                  <DefaultButton
                    text="Previous UPS"
                    className="mr-8 borderless-btn"
                    disabled={
                      state.allFloorsDropdownList[1].key ===
                        state.searchObj.floorId &&
                      state.allUpsDropdownList[0].key === state.searchObj.upsId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(true);
                    }}
                  />
                  <DefaultButton
                    text="Next UPS"
                    disabled={
                      state.allFloorsDropdownList[
                        state.allFloorsDropdownList.length - 1
                      ].key === state.searchObj.floorId &&
                      state.allUpsDropdownList[
                        state.allUpsDropdownList.length - 1
                      ].key === state.searchObj.upsId
                    }
                    onClick={() => {
                      onNextOrPrevFunc(false);
                    }}
                    className="borderless-btn"
                  />
                </div>
              </div> */}
            </Stack>
          )}
        </React.Fragment>
      ) : (
        <NoDataTile
          title="No Datacenter Found"
          description="Datacenter either deleted or not created"
        />
      )}
      {state.manageActionsCallout.isOpen && (
        <Callout
          styles={{ root: { width: 95, padding: 20 } }}
          role="alertdialog"
          ariaLabelledBy={
            state.manageActionsCallout && state.manageActionsCallout.data?._id
          }
          gapSpace={0}
          target={state.manageActionsCallout.element}
          directionalHint={DirectionalHint.leftCenter}
          onDismiss={() => handleCallOutOpenClose(false)}
        // setInitialFocus={true}
        >
          <Stack tokens={childrenGap8}>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleOpenDialog(
                    true,
                    state.manageActionsCallout.data?._id as string
                  )
                }
                className="callout-options"
              >
                Edit
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleAcceptOrReject(
                    state.manageActionsCallout.data?._id as string,
                    true
                  )
                }
                className="callout-options"
              >
                Accept
              </span>
            </Stack.Item>
            <Stack.Item className="pointer">
              <span
                onClick={() =>
                  handleRejectOpenDialog(
                    state.manageActionsCallout.data?._id as string,
                    state.manageActionsCallout.data?.remarks
                  )
                }
                className="callout-options"
              >
                Reject
              </span>
            </Stack.Item>
          </Stack>
        </Callout>
      )}
      {state.manageUpsDialog.isOpen && (
        <ManageUPSDialog
          closeManageDialog={(data: IUPSReading) => handleCloseDialog(data)}
          data={state.manageUpsDialog.data}
          handleLoading={handleLoading}
          threshold={threshold}
          datacenterId={params.dataCenterId}
        />
      )}
      {state.manageRejectDialog.isOpen && (
        <ManageAllRejectDialog
          handleRejectCloseDialog={(isSuccess: boolean, remarks?: string) =>
            handleRejectCloseDialog(isSuccess, remarks)
          }
          remarks={state.manageRejectDialog.remarks}
          subText="ups reading"
        // handleLoading={handleLoading}
        />
      )}
    </React.Fragment>
  );
};

export default UpsMain;
